import(/* webpackMode: "eager" */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/src/app/[locale]/mine/[slug]/page.jsx");
